var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorrectnessBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H28C30.2091 0 32 1.79086 32 4V28C32 30.2091 30.2091 32 28 32H4C1.79086 32 0 30.2091 0 28V4Z",
    fill: "#F8EFE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3178 16.5938L19.3278 22.2778C19.3391 22.3447 19.3298 22.4135 19.3009 22.4749C19.2721 22.5364 19.2252 22.5875 19.1665 22.6216C19.1077 22.6557 19.04 22.671 18.9724 22.6656C18.9047 22.6601 18.8403 22.6341 18.7878 22.5911L16.4012 20.7997C16.286 20.7137 16.146 20.6672 16.0022 20.6672C15.8583 20.6672 15.7184 20.7137 15.6032 20.7997L13.2125 22.5904C13.16 22.6334 13.0957 22.6593 13.0282 22.6648C12.9606 22.6702 12.8929 22.655 12.8343 22.621C12.7756 22.587 12.7287 22.536 12.6998 22.4746C12.6709 22.4133 12.6614 22.3446 12.6725 22.2778L13.6818 16.5938",
    stroke: "#D09229",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17.333C18.2091 17.333 20 15.5421 20 13.333C20 11.1239 18.2091 9.33301 16 9.33301C13.7909 9.33301 12 11.1239 12 13.333C12 15.5421 13.7909 17.333 16 17.333Z",
    stroke: "#D09229",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectnessBadge);
export default __webpack_public_path__ + "static/media/CorrectnessBadge.59cc5c88b84b599b9648eb065b4f1672.svg";
export { ForwardRef as ReactComponent };